import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const minDateByControl = (
  dateControl: FormControl<Date | null>,
  minDate: FormControl<Date | null>
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === undefined || control.value === null) {
      return null;
    }
    try {
      const dateInControl: Date | null = dateControl.value;
      const dateInReferenceControl: Date | null = minDate.value;
      const errors =
        dateInControl &&
        dateInReferenceControl &&
        dateInControl > dateInReferenceControl
          ? null
          : !dateInReferenceControl || !dateInControl
            ? null
            : { minDate: true };
      return errors;
    } catch {
      return { minDateNoDate: true };
    }
  };
};
